module.exports = __webpack_public_path__ + "static/vector-human-813d0cd377c42fc5556a4d922a301d33.png";